"use client";

import { useRuntimeConfig } from "@lib/env";
import { useEffect, useState } from "react";
import { ChatwootWidget } from "../chatwoot";
import SmartlookProvider from "../smartlook-provider";

export default function SmartlookWrapper() {
  const [customer, setCustomer] = useState(null);
  const { config, loading } = useRuntimeConfig();

  useEffect(() => {
    const fetchCustomer = async () => {
      try {
        const res = await fetch("/api/me");
        const data = await res.json();
        setCustomer(data);
      } catch (err) {
        setCustomer(null);
      }
    };

    fetchCustomer();
  }, []);

  if (loading) return null;

  const websiteData = {
    websiteToken: config.NEXT_PUBLIC_CHATWOOT_TOKEN ?? "",
    baseUrl: config.NEXT_PUBLIC_CHATWOOT_URL ?? "",
  };

  return (
    <>
      <SmartlookProvider customer={customer} />
      <ChatwootWidget {...websiteData} />
    </>
  );
}
